import Sorting from './Sorting.container';

export default Sorting;
